import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onStartJourney: () => void;
}

const HeroSection = ({ onStartJourney }: HeroSectionProps) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 py-16 md:py-24 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-muted to-background opacity-60" />
      
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-primary/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-accent/10 rounded-full blur-3xl" />
      
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Hero Image */}
        <div className="mb-8 md:mb-12 flex justify-center">
          <div className="relative w-48 h-48 md:w-64 md:h-64 rounded-full overflow-hidden shadow-soft-xl">
            <AppImage
              src="https://images.unsplash.com/photo-1713201357737-48f47ac2490a"
              alt="Smiling woman in white athletic wear holding green smoothie in bright modern kitchen"
              className="object-cover"
              fill
              priority />
            
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-text-primary mb-6 leading-tight">
<span className="text-primary">LivsmartCoach</span> <br />
          Your Personal <span className="text-primary">Wellness Journey</span> Starts Here
        </h1>

        {/* Value Proposition */}
        <p className="text-lg md:text-xl text-text-secondary mb-8 md:mb-12 max-w-2xl mx-auto leading-relaxed">
          Get personalized healthy lifestyle guidance through AI-powered conversations. Create sustainable wellness routines tailored to your unique needs and goals.
        </p>

        {/* CTA Button */}
        <button
          onClick={onStartJourney}
          className="group inline-flex items-center gap-3 px-8 py-4 md:px-10 md:py-5 bg-primary text-primary-foreground rounded-lg text-lg md:text-xl font-semibold shadow-soft-lg hover:shadow-soft-xl transition-smooth focus-ring touch-target">
          
          Start Your Wellness Journey
          <Icon
            name="ArrowRightIcon"
            size={24}
            className="group-hover:translate-x-1 transition-smooth" />
          
        </button>

        {/* Trust Indicators */}
        <div className="mt-12 md:mt-16 flex flex-wrap justify-center gap-6 md:gap-8 text-sm md:text-base text-text-secondary">
          <div className="flex items-center gap-2">
            <Icon name="ShieldCheckIcon" size={20} className="text-primary" />
            <span>Privacy Protected</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-primary" />
            <span>AI-Powered Guidance</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="HeartIcon" size={20} className="text-primary" />
            <span>Non-Medical Advice</span>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;